import {Nullable} from '../../app/TypeHelpers'

export default class Equipment {
    id: number
    name: string
    condominiumCd: string
    explainText: string
    parentEquipmentId: Nullable<number>
    parentEquipmentName: Nullable<string>
    reservationCountMonthly: Nullable<number>
    reservationCountDaily: Nullable<number>
    lotteryEntryCountMonthly: Nullable<number>
    version: number

    constructor(
        id: number,
        name: string,
        condominiumCd: string,
        explainText: string,
        parentEquipmentId: Nullable<number>,
        parentEquipmentName: Nullable<string>,
        reservationCountMonthly: Nullable<number>,
        reservationCountDaily: Nullable<number>,
        lotteryEntryCountMonthly: Nullable<number>,
        version: number,
    ) {
        this.id = id
        this.name = name
        this.condominiumCd = condominiumCd
        this.explainText = explainText
        this.parentEquipmentId = parentEquipmentId
        this.parentEquipmentName = parentEquipmentName
        this.reservationCountMonthly = reservationCountMonthly
        this.reservationCountDaily = reservationCountDaily
        this.lotteryEntryCountMonthly = lotteryEntryCountMonthly
        this.version = version
    }

    static from(json: any): Equipment {
        return new Equipment(
            json.id,
            json.name,
            json.condominiumCd,
            json.explainText,
            json.parentEquipmentId,
            json.parentEquipmentName,
            json.reservationCountMonthly,
            json.reservationCountDaily,
            json.lotteryEntryCountMonthly,
            json.version,
        )
    }
}
